import { gql, useMutation } from '@provision/graphql-client';
import { useCallback } from 'react';

const GENERATE_AF_MAGIC_LOGIN_URL_QUERY = gql`
  mutation GenerateAFMagicLoginUrl($params: GenerateAFMagicLoginUrlInput!) {
    generateAFMagicLoginUrl(params: $params) {
      url
    }
  }
`;

interface GenerateAFMagicLoginUrlQuery {
  generateAFMagicLoginUrl: {
    url: string;
  };
}

export const useActivationFlowUrl = () => {
  const [generateAFMagicLoginUrlMutation] = useMutation<GenerateAFMagicLoginUrlQuery>(
    GENERATE_AF_MAGIC_LOGIN_URL_QUERY,
  );

  const generateAfMagicLoginUrl = useCallback(
    async (params: {
      email: string;
      clientId: string;
      partnerId: number;
      addressId?: string;
      disableLink?: boolean;
    }) => {
      const { data } = await generateAFMagicLoginUrlMutation({
        variables: {
          params,
        },
      });

      return data?.generateAFMagicLoginUrl || { url: '' };
    },
    [generateAFMagicLoginUrlMutation],
  );

  return {
    generateAfMagicLoginUrl,
  };
};
